// extracted by mini-css-extract-plugin
export default {"textTitle":"FieldReadOnly_textTitle__vyTPe","textLink":"FieldReadOnly_textLink__r1xuo","textValue":"FieldReadOnly_textValue__uaeSB"};